import React, { useContext, useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import ComparedSalesByLocation from "./ComparedSalesByLocation";
import ComparedNetSalesAndTransactions from "./ComparedNetSalesAndTransactions";
import ComparedTransactionsByLocation from "./ComparedTransactionsByLocation";
import ComparedSalesByTender from "./ComparedSalesByTender";
import ComparedSalesInsightAreaRetail from "./ComparedSalesInsightAreaRetail";
import ComparedNetSalesQuantity from "./ComparedNetSalesQuantity";


const ComparedHospitalityBusinessDashboard = () => (
        <Box sx={{ width: '100%', flexGrow: 1, height: 'auto'}}>
            <Box>
                <ComparedSalesInsightAreaRetail/>
            </Box>
            <Box sx={{display:'flex', flexDirection:'row', width:'auto', justifyContent: 'space-between' }}>
                <Box sx={{width: '50%'}}>
                    <ComparedSalesByLocation/>
                </Box>
                <Box sx={{width: '50%'}}>
                    <ComparedTransactionsByLocation/>
                </Box>
            </Box>
            <Box sx={{ width:'auto', marginY: '20px'}}>
                <ComparedNetSalesAndTransactions/>
            </Box>
            <Box sx={{ width:'auto', marginY: '20px'}}>
                <ComparedSalesByTender/>
            </Box>
            <Box sx={{ width:'auto', marginY: '20px'}}>
                <ComparedNetSalesQuantity/>
            </Box>
        </Box>
        
        
    );

export default ComparedHospitalityBusinessDashboard;
